export function ClinicLoading() {
    return (
        <main className='main-content main-content--initial' id='main'>
            <section className='main-content__section'>
                <span className='skeleton-box'></span>
            </section>
        </main>
    );
}
